import React from 'react';
import moment from 'moment';
import { formatNumber } from 'utils/formatting';
import { getDateTime } from '../common';

export function UpcomingAuctionBidInfo({ data }) {
  const fieldConfig = {
    fields: [
      { label: 'Status', value: 'Upcoming' },
      { label: 'Minimum Bid', value: formatNumber(data.minimumBid) },
      { label: 'Bid Increment', value: formatNumber(data.bidIncrement) },
      {
        label: 'Auction Begins',
        value: (
          <div>
            <div className="auction-date">
              {getDateTime(data.startTime).format('MM/DD/YY')}
            </div>
            {getDateTime(data.startTime).format('hh:mm A')}{' '}
            {moment.tz(moment.tz.guess()).format('z')}
          </div>
        )
      },
      {
        label: 'Auction Ends',
        value: (
          <div>
            <div className="auction-date">
              {getDateTime(data.endTime).format('MM/DD/YY')}
            </div>
            {getDateTime(data.endTime).format('hh:mm A')}{' '}
            {moment.tz(moment.tz.guess()).format('z')}
          </div>
        )
      }
    ]
  };

  return (
    <div className="auction-fields">
      {fieldConfig.fields.map((field, index) => (
        <AuctionField
          key={index}
          label={field.label}
          value={field.value}
          subvalue={field.subvalue}
        />
      ))}
    </div>
  );
}

export function InProgressAuctionBidInfo({
  data,
  bids,
  endTime,
  minimumInput
}) {
  const highestBidder = bids.length ? (
    <span className="notranslate">{bids[0].user.displayName}</span>
  ) : (
    ''
  );

  const fieldConfig = {
    fields: [
      {
        label: 'Status',
        value: data.status === 'InProgress' ? 'Open' : 'Closed'
      },
      { label: 'Minimum Bid', value: formatNumber(minimumInput) },
      {
        label: 'Bid Increment',
        value: bids.length ? formatNumber(data.bidIncrement) : ''
      },
      {
        label: 'Current Top Bid',
        value: bids.length ? formatNumber(bids[0].amount) : '',
        subValue: highestBidder
      }
    ]
  };

  return (
    <div className="auction-fields">
      {fieldConfig.fields.map((field, index) => (
        <AuctionField
          key={index}
          className={field.className}
          label={field.label}
          value={field.value}
          subvalue={field.subValue}
        />
      ))}
    </div>
  );
}

const AuctionField = ({ className, label, value, subvalue }) => (
  <div className={`auction-field ${className || ''}`}>
    <div className="auction-field-title">{label}</div>
    {subvalue ? (
      <div className="auction-field-subcontainer">
        <div className="auction-field-value">{value}</div>
        <div className="auction-field-subvalue">{subvalue}</div>
      </div>
    ) : (
      <div className="auction-field-value">{value}</div>
    )}
  </div>
);
